;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Model = APP.module('Model');

	Model.PlayerPosition = Backbone.Model.extend({
		defaults: {
			id:         0,
			plural:     "",
			name:       "",
			short_name: ""
		}
	});

}(window, APP, Backbone, Marionette, $, _));
